import { Component } from 'react';
import HomePlayInput from './home-play-input';
import HomePlayFormErrorConsole from './home-play-form-error-console';
import { validatePassword } from '../../../services/utils/form';
import { activateHomePlayer } from '../../../modules/user_api';

class HomePlayForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      canSend: false,
      show: true,
      formData: {},
      submitting: false,
      gotErrors: false,
      activated: false,
      errors: [],
    };
  }

  splitPlayerName(playerName) {
    let firstName;
    let lastName;
    if (playerName) {
      firstName = playerName.split(' ').slice(0, -1).join(' ');
      lastName = playerName.split(' ').slice(-1).join(' ');
      return [firstName, lastName];
    } else {
      return ['', ''];
    }
  }

  componentDidMount() {
    const { player } = this.props;

    let playerName = ['', ''];
    if (player) {
      playerName = this.splitPlayerName(player.name);
    }

    const formData = {
      first_name: playerName[0],
      last_name: playerName[1],
      login: '',
      password: '',
    };

    this.setState({ formData: formData });
  }

  updateFormData(inputName, newValue) {
    // let {formData} = this.state;

    // let newFormData = {};
    // Object.assign(newFormData, formData);

    // newFormData[inputName] = newValue;
    this.setState({ ...this.state, formData: { ...this.state.formData, [inputName]: newValue } });
  }

  validateForm(formData) {
    let gotErrors = false;
    const errors = [];
    const firstName = formData.first_name;
    const lastName = formData.last_name;
    const password = formData.password;
    const login = formData.login;

    if (login.length < 6) {
      gotErrors = true;
      errors.push('User name must be at least 6 characters long');
    }

    if (firstName.length < 2) {
      gotErrors = true;
      errors.push('First name must be at least 2 characters long');
    }

    if (lastName.length < 2) {
      gotErrors = true;
      errors.push('Last name must be at least 2 characters long');
    }

    if (validatePassword(password) === 'weak') {
      gotErrors = true;
      errors.push('Password too weak');
    }
    this.setState({ gotErrors: gotErrors, errors: errors });
    return !gotErrors;
  }

  async submitForm(e) {
    const { player, activation_done } = this.props;
    e.preventDefault();
    const { formData, submitting } = this.state;
    if (submitting) {
      return;
    }
    this.setState({ submitting: true });
    const valid = this.validateForm(formData);
    if (!valid) {
      this.setState({ submitting: false });
      return;
    }
    const activationResponse = await activateHomePlayer(
      player.id,
      formData.first_name,
      formData.last_name,
      formData.login,
      formData.password
    );
    if (activationResponse && activationResponse.data) {
      const activationData = activationResponse.data;

      if (activationData.success) {
        this.setState({ activated: true });
        const newUser = activationData.new_user;
        activation_done(newUser);
      } else {
        this.setState({ gotErrors: true, errors: activationData.errors, submitting: false });
      }
    }
  }

  render() {
    const { player } = this.props;
    const { submitting, gotErrors, errors, activated } = this.state;
    let playerName = ['', ''];
    if (player) {
      playerName = this.splitPlayerName(player.name);
    }
    return (
      <div className="home_play_form_container">
        <div className="home_play_section_title">Activate Home Play</div>
        <HomePlayFormErrorConsole show={gotErrors} errors={errors} />
        <form>
          <HomePlayInput
            label="First Name"
            input_id="first_name"
            default_value={playerName[0]}
            updateForm={this.updateFormData.bind(this)}
            required={true}
          />
          <HomePlayInput
            label="Last Name"
            input_id="last_name"
            default_value={playerName[1]}
            updateForm={this.updateFormData.bind(this)}
            required={true}
          />
          <HomePlayInput
            label="User Name"
            input_id="login"
            default_value={player.login}
            updateForm={this.updateFormData.bind(this)}
            required={true}
          />
          <HomePlayInput
            label="Password"
            input_id="password"
            special_type="password"
            updateForm={this.updateFormData.bind(this)}
            required={true}
          />
          {!submitting && (
            <button className="home_play_form_submit center" onClick={this.submitForm.bind(this)}>
              Activate
            </button>
          )}
          {submitting && (
            <div>
              Working... <i className="fa fa-spin fa-spinner"></i>
            </div>
          )}
          {activated && (
            <div className="home_play_form_activated">
              activated successfully <i className="fa fa-check activation icon"></i>
            </div>
          )}
        </form>
      </div>
    );
  }
}

export default HomePlayForm;
